import axiosInstance from '../utils/AxiosConfig';

export const getClients = async (
  page = 1,
  pageSize = 10,
  searchTerm = '',
  options = {}
) => {
  const {
    sortField,
    sortDirection,
    filterField,
    filterOperator,
    filterValue
  } = options;

  const params = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString()
  });
  
  // Agregar search solo si hay contenido
  if (searchTerm && typeof searchTerm === 'string' && searchTerm.trim()) {
    params.append('search', searchTerm.trim());
  }

  if (sortField) {
    params.append('sortField', sortField);
  }

  if (sortDirection) {
    params.append('sortDirection', sortDirection);
  }

  if (filterField) {
    params.append('filterField', filterField);
  }

  if (filterOperator) {
    params.append('filterOperator', filterOperator);
  }

  if (filterValue !== undefined && filterValue !== null && String(filterValue).trim() !== '') {
    params.append('filterValue', String(filterValue).trim());
  }
  
  const response = await axiosInstance.get(`/clients?${params}`);
  return response.data.data;
};

export const submitClient = async (client) => {
  const response = await axiosInstance.post('/clients', {
    client: {
      ci: client.ci,
      first_name: client.firstName,
      last_name: client.lastName,
      email: client.email,
      phone: client.phone
    },
    company: null
  });
  return response.data.data.client;
};

export const deleteClient = async (ci) => {
  await axiosInstance.delete(`/clients/${ci}`);
};

export const getClientByCI = async (ci) => {
  const response = await axiosInstance.get(`/clients/${ci}`);
  return response.data.data;
};

export const getClientInvoices = async (ci, page = 1, pageSize = 20) => {
  const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  const response = await axiosInstance.get(`/clients/${ci}/invoices?${params}`);
  return response.data.data;
};
